export { EditRoomViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
